import React from 'react';
import './portfolio.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import portfolioData from '../../portfolio.json';

export default function Portfolio() {
  const { portfolio } = portfolioData;

  return (
    <section className="portfolio section" id='portfolio'>
      <h2 className="section__title">{portfolio.title}</h2>
      <span className="section__subtitle">{portfolio.subtitle}</span>

      <div className="portfolio__container container grid">
        {portfolio.projects.map((project, index) => (
          <div className="portfolio__content" key={index}>
            <img src={process.env.PUBLIC_URL + project.image} alt="Project" className="portfolio__img" />
            <div>
              <h3 className="portfolio__title">{project.title}</h3>
              <a href={project.link} className="portfolio__button button" target="_blank" rel="noreferrer">
                Demo Here<p>  </p><FontAwesomeIcon icon={faArrowRight} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}